export default __webpack_public_path__ + "static/media/uploader-medtronic-1.8b86063d.png";